// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 预约表单优化 */
.booking-page { min-height:100vh; background:var(--color-bg); }

.booking-form { margin:18px 0 26px; padding:28px 24px 30px; position:relative; overflow:hidden; }
.booking-form::before { content:""; position:absolute; inset:0; background:radial-gradient(circle at 85% 15%,rgba(99,102,241,.18),rgba(255,255,255,0)); pointer-events:none; }
.booking-form::after { content:"预约信息"; position:absolute; top:0; left:0; padding:6px 14px 8px 18px; background:linear-gradient(135deg,var(--color-primary),var(--color-primary-accent)); color:#fff; font-size:.7rem; font-weight:600; letter-spacing:1px; border-radius:0 0 14px 0; box-shadow:0 2px 6px -3px rgba(0,0,0,.3); }

.form-group { margin:0 0 22px; position:relative; animation:fadeSlideUp .6s both; }
.form-group:last-of-type { margin-bottom:26px; }
.form-group label { display:block; margin:0 0 10px; color:var(--color-text); font-weight:600; font-size:.8rem; letter-spacing:.5px; text-transform:uppercase; opacity:.85; }
.form-group input, .form-group select, .form-group textarea {
  width: 100%;
  min-height: 48px; /* 确保触摸目标 */
  padding: 14px 16px;
  font-size: 16px; /* 防止iOS缩放 */
  border-radius: 12px;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.form-group input, .form-group select {
  line-height: 1.2;
}

/* 特定输入类型优化 */
.form-group input[type="tel"] {
  font-family: monospace; /* 数字更清晰 */
}

.form-group input[type="email"] {
  text-transform: lowercase; /* 自动小写 */
}

.form-group input[type="date"],
.form-group input[type="time"] {
  min-height: 52px; /* 日期时间选择器需要更大空间 */
}

/* 输入增强反馈 */
.form-group input:focus, .form-group select:focus, .form-group textarea:focus { background:var(--color-surface); }

.form-group textarea { min-height:92px; }

/* 校验 / 状态占位符样式 */

.submit-btn { width:100%; padding:16px 18px; border-radius:16px; font-size:1rem; letter-spacing:.5px; position:relative; }
.submit-btn:active { transform:translateY(0); }
.submit-btn[disabled] { filter:saturate(.5) brightness(.9); }

/* 加载动画指示（按钮内模拟） */
.submit-btn[disabled] { cursor:not-allowed; }
.submit-btn[disabled]::after { content:attr(data-loading); position:absolute; inset:0; display:flex; align-items:center; justify-content:center; font-size:.9rem; }

@media (max-width:640px) {
  .booking-form { margin:14px 0 40px; padding:24px 18px 28px; }
}

/* 移动端表单优化 */
@media (max-width: 480px) {
  .booking-form {
    margin: 12px 0 30px;
    padding: 20px 16px 24px;
  }

  .form-group {
    margin-bottom: 20px;
  }

  .form-group label {
    font-size: .85rem;
    margin-bottom: 8px;
  }

  .form-group input, .form-group select, .form-group textarea {
    font-size: 16px; /* 防止iOS缩放 */
    min-height: 48px;
    padding: 16px;
    border-radius: 14px;
  }

  .form-group textarea {
    min-height: 100px;
    resize: vertical;
  }

  .submit-btn {
    padding: 16px 20px;
    font-size: 1.1rem;
    min-height: 52px;
    border-radius: 16px;
  }
}

@media (max-width: 360px) {
  .booking-form {
    padding: 18px 14px 22px;
  }

  .form-group input, .form-group select, .form-group textarea {
    padding: 14px;
    min-height: 44px;
  }

  .form-group textarea {
    min-height: 90px;
  }

  .submit-btn {
    min-height: 48px;
    font-size: 1rem;
  }
}

/* 触摸设备表单优化 */
@media (pointer: coarse) {
  .form-group input, .form-group select, .form-group textarea {
    min-height: 52px;
    padding: 16px 18px;
  }

  .form-group textarea {
    min-height: 120px;
  }

  .submit-btn {
    min-height: 56px;
    padding: 18px 24px;
  }
}

/* 表单验证状态 */
.form-group input:invalid:not(:placeholder-shown) {
  border-color: var(--color-danger);
  box-shadow: 0 0 0 3px rgba(245, 108, 108, 0.1);
}

.form-group input:valid:not(:placeholder-shown) {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

/* 焦点状态优化 */
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
  background: var(--color-surface);
}
`, "",{"version":3,"sources":["webpack://./src/components/BookingPage.css"],"names":[],"mappings":"AAAA,WAAW;AACX,gBAAgB,gBAAgB,EAAE,0BAA0B,EAAE;;AAE9D,gBAAgB,kBAAkB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAChG,wBAAwB,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,sFAAsF,EAAE,mBAAmB,EAAE;AAC7K,uBAAuB,cAAc,EAAE,iBAAiB,EAAE,KAAK,EAAE,MAAM,EAAE,yBAAyB,EAAE,mFAAmF,EAAE,UAAU,EAAE,eAAe,EAAE,eAAe,EAAE,kBAAkB,EAAE,wBAAwB,EAAE,wCAAwC,EAAE;;AAE/T,cAAc,eAAe,EAAE,iBAAiB,EAAE,8BAA8B,EAAE;AAClF,2BAA2B,kBAAkB,EAAE;AAC/C,oBAAoB,aAAa,EAAE,eAAe,EAAE,uBAAuB,EAAE,eAAe,EAAE,eAAe,EAAE,mBAAmB,EAAE,wBAAwB,EAAE,WAAW,EAAE;AAC3K;EACE,WAAW;EACX,gBAAgB,EAAE,WAAW;EAC7B,kBAAkB;EAClB,eAAe,EAAE,YAAY;EAC7B,mBAAmB;EACnB,kFAAkF;AACpF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,sBAAsB,EAAE,UAAU;AACpC;;AAEA;EACE,yBAAyB,EAAE,SAAS;AACtC;;AAEA;;EAEE,gBAAgB,EAAE,kBAAkB;AACtC;;AAEA,WAAW;AACX,gFAAgF,+BAA+B,EAAE;;AAEjH,uBAAuB,eAAe,EAAE;;AAExC,iBAAiB;;AAEjB,cAAc,UAAU,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,cAAc,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AACzH,qBAAqB,uBAAuB,EAAE;AAC9C,wBAAwB,kCAAkC,EAAE;;AAE5D,kBAAkB;AAClB,wBAAwB,kBAAkB,EAAE;AAC5C,+BAA+B,0BAA0B,EAAE,iBAAiB,EAAE,OAAO,EAAE,YAAY,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAElK;EACE,gBAAgB,kBAAkB,EAAE,sBAAsB,EAAE;AAC9D;;AAEA,YAAY;AACZ;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe,EAAE,YAAY;IAC7B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,aAAa;AACb;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,WAAW;AACX;EACE,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,WAAW;AACX;;;EAGE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;EAC7C,gCAAgC;AAClC","sourcesContent":["/* 预约表单优化 */\r\n.booking-page { min-height:100vh; background:var(--color-bg); }\r\n\r\n.booking-form { margin:18px 0 26px; padding:28px 24px 30px; position:relative; overflow:hidden; }\r\n.booking-form::before { content:\"\"; position:absolute; inset:0; background:radial-gradient(circle at 85% 15%,rgba(99,102,241,.18),rgba(255,255,255,0)); pointer-events:none; }\r\n.booking-form::after { content:\"预约信息\"; position:absolute; top:0; left:0; padding:6px 14px 8px 18px; background:linear-gradient(135deg,var(--color-primary),var(--color-primary-accent)); color:#fff; font-size:.7rem; font-weight:600; letter-spacing:1px; border-radius:0 0 14px 0; box-shadow:0 2px 6px -3px rgba(0,0,0,.3); }\r\n\r\n.form-group { margin:0 0 22px; position:relative; animation:fadeSlideUp .6s both; }\r\n.form-group:last-of-type { margin-bottom:26px; }\r\n.form-group label { display:block; margin:0 0 10px; color:var(--color-text); font-weight:600; font-size:.8rem; letter-spacing:.5px; text-transform:uppercase; opacity:.85; }\r\n.form-group input, .form-group select, .form-group textarea {\r\n  width: 100%;\r\n  min-height: 48px; /* 确保触摸目标 */\r\n  padding: 14px 16px;\r\n  font-size: 16px; /* 防止iOS缩放 */\r\n  border-radius: 12px;\r\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\r\n}\r\n\r\n.form-group input, .form-group select {\r\n  line-height: 1.2;\r\n}\r\n\r\n/* 特定输入类型优化 */\r\n.form-group input[type=\"tel\"] {\r\n  font-family: monospace; /* 数字更清晰 */\r\n}\r\n\r\n.form-group input[type=\"email\"] {\r\n  text-transform: lowercase; /* 自动小写 */\r\n}\r\n\r\n.form-group input[type=\"date\"],\r\n.form-group input[type=\"time\"] {\r\n  min-height: 52px; /* 日期时间选择器需要更大空间 */\r\n}\r\n\r\n/* 输入增强反馈 */\r\n.form-group input:focus, .form-group select:focus, .form-group textarea:focus { background:var(--color-surface); }\r\n\r\n.form-group textarea { min-height:92px; }\r\n\r\n/* 校验 / 状态占位符样式 */\r\n\r\n.submit-btn { width:100%; padding:16px 18px; border-radius:16px; font-size:1rem; letter-spacing:.5px; position:relative; }\r\n.submit-btn:active { transform:translateY(0); }\r\n.submit-btn[disabled] { filter:saturate(.5) brightness(.9); }\r\n\r\n/* 加载动画指示（按钮内模拟） */\r\n.submit-btn[disabled] { cursor:not-allowed; }\r\n.submit-btn[disabled]::after { content:attr(data-loading); position:absolute; inset:0; display:flex; align-items:center; justify-content:center; font-size:.9rem; }\r\n\r\n@media (max-width:640px) {\r\n  .booking-form { margin:14px 0 40px; padding:24px 18px 28px; }\r\n}\r\n\r\n/* 移动端表单优化 */\r\n@media (max-width: 480px) {\r\n  .booking-form {\r\n    margin: 12px 0 30px;\r\n    padding: 20px 16px 24px;\r\n  }\r\n\r\n  .form-group {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .form-group label {\r\n    font-size: .85rem;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .form-group input, .form-group select, .form-group textarea {\r\n    font-size: 16px; /* 防止iOS缩放 */\r\n    min-height: 48px;\r\n    padding: 16px;\r\n    border-radius: 14px;\r\n  }\r\n\r\n  .form-group textarea {\r\n    min-height: 100px;\r\n    resize: vertical;\r\n  }\r\n\r\n  .submit-btn {\r\n    padding: 16px 20px;\r\n    font-size: 1.1rem;\r\n    min-height: 52px;\r\n    border-radius: 16px;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .booking-form {\r\n    padding: 18px 14px 22px;\r\n  }\r\n\r\n  .form-group input, .form-group select, .form-group textarea {\r\n    padding: 14px;\r\n    min-height: 44px;\r\n  }\r\n\r\n  .form-group textarea {\r\n    min-height: 90px;\r\n  }\r\n\r\n  .submit-btn {\r\n    min-height: 48px;\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n/* 触摸设备表单优化 */\r\n@media (pointer: coarse) {\r\n  .form-group input, .form-group select, .form-group textarea {\r\n    min-height: 52px;\r\n    padding: 16px 18px;\r\n  }\r\n\r\n  .form-group textarea {\r\n    min-height: 120px;\r\n  }\r\n\r\n  .submit-btn {\r\n    min-height: 56px;\r\n    padding: 18px 24px;\r\n  }\r\n}\r\n\r\n/* 表单验证状态 */\r\n.form-group input:invalid:not(:placeholder-shown) {\r\n  border-color: var(--color-danger);\r\n  box-shadow: 0 0 0 3px rgba(245, 108, 108, 0.1);\r\n}\r\n\r\n.form-group input:valid:not(:placeholder-shown) {\r\n  border-color: var(--color-primary);\r\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\r\n}\r\n\r\n/* 焦点状态优化 */\r\n.form-group input:focus,\r\n.form-group select:focus,\r\n.form-group textarea:focus {\r\n  outline: none;\r\n  border-color: var(--color-primary);\r\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\r\n  background: var(--color-surface);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
